module.exports = __webpack_public_path__ + "img/sberbank.df56bc3a.png";